import { useEffect, useState } from "react"
import _get from "lodash/get"
import _isNill from "lodash/isNil"
import _split from "lodash/split"

import {
  getProductDetail,
  getMonthsDetailing,
  monthsDetailingLoader
} from "services/state/actions"

import { getMonthsDetailingFiltered } from "./getMonthsDetailingFiltered"

export const useDetailsProduct =
  (productSelected, documentNumber) => (dispatch, getState) => {
    const [detailProduct, setDetailProduct] = useState({})
    const { invoices, products } = getState()
    const loadingDetailProducts = products.detail.loading

    const details = {
      products: _get(productSelected, "assetFullName", ""),
      agreementId: _get(productSelected, "agreementId", ""),
      documentNumber: _get(
        productSelected,
        "customer.primaryDocumentNumber",
        documentNumber
      ).toString(),
      finalDayToPay: _get(detailProduct, "billingDueDay", "")
    }

    useEffect(() => {
      if (_isNill(productSelected)) return

      const getDetail = async () => {
        const response = await getProductDetail(productSelected)(
          dispatch,
          getState
        )
        const data = _get(response, "payload.data", {})

        setDetailProduct(data)
      }

      getDetail()
    }, [productSelected])

    useEffect(() => {
      if (!invoices.data || _isNill(productSelected)) return
      if (loadingDetailProducts) return

      const getMonthsDetail = async () => {
        monthsDetailingLoader(true)(dispatch)
        const filteredInvoices = getMonthsDetailingFiltered(
          { ...productSelected, ...detailProduct },
          invoices.data
        )
        await getMonthsDetailing(filteredInvoices)(dispatch)
        monthsDetailingLoader(false)(dispatch)
      }

      getMonthsDetail()
    }, [invoices.data, loadingDetailProducts, detailProduct])

    return {
      ...details,
      ...detailProduct,
      activationDate: _split(detailProduct.activationDate, " ")[0]
    }
  }



// WEBPACK FOOTER //
// ./src/scenes/DetailingPosPreControle/utils/useDetailsProduct.js